import React from 'react'
import LeafletMapsContainer from '../../../../Components/Miscellaneous/Maps/LeafletMaps'

export default function LeafletMaps() {
  return (
    <div className='page-body'>
      <LeafletMapsContainer />
    </div>
  )
}